import { cn } from "@/components/ui/cn";

interface MonthDividerProps {
  label: string;
  className?: string;
}

export function MonthDivider({ label, className }: MonthDividerProps) {
  return (
    <div className={cn("flex items-center gap-4", className)}>
      <span className="text-body-2-medium text-text-primary whitespace-nowrap">
        {label}
      </span>
      <div className="flex-1 border-t border-border-subtle" />
    </div>
  );
}
